import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-e92c4f3e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "left-container" }, null, -1));
const _hoisted_3 = { class: "center-container" };
const _hoisted_4 = {
    id: "MainTitle",
    class: "text-lg sm:text-xl md:text-2xl"
};
const _hoisted_5 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_6 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_7 = {
    id: "MainTitle",
    class: "text-lg sm:text-lg md:text-lg"
};
const _hoisted_8 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_9 = {
    id: "MainTitle",
    class: "text-lg sm:text-lg md:text-lg"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_12 = {
    id: "MainTitle",
    class: "text-md sm:text-md md:text-md"
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_14 = {
    id: "MainTitle",
    class: "text-lg sm:text-lg md:text-lg"
};
const _hoisted_15 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_17 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_18 = { class: "component-container" };
const _hoisted_19 = { class: "right-container" };
const _hoisted_20 = { key: 0 };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("template", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_input = _resolveComponent("hit-input");
    const _component_hit_form = _resolveComponent("hit-form");
    const _component_hit_panel = _resolveComponent("hit-panel");
    const _component_hit_button = _resolveComponent("hit-button");
    const _component_hit_banner = _resolveComponent("hit-banner");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_title_1')), 1),
                _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_1_1')), 1),
                _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_1_2')), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_title_2')), 1),
                _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_2_1')), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_title_3')), 1),
                _createElementVNode("h6", {
                    class: "text-sm sm:text-base md:text-lg text-gray-500",
                    innerHTML: _ctx.t('admin-ui.register_email_form_explanation_title_3_1')
                }, null, 8, _hoisted_10),
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_title_3_2')), 1),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_title_5')), 1),
                _createElementVNode("h6", _hoisted_15, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_title_5_1', {
                    email: 'support@ficos.com',
                    phone1: '+32 80 28 11 40',
                    phone2: '+352 20 88 20 23',
                })), 1),
                _hoisted_16,
                _createElementVNode("h6", _hoisted_17, _toDisplayString(_ctx.t('admin-ui.register_email_form_explanation_title_4')), 1),
                _createElementVNode("div", null, [
                    _createVNode(_component_hit_panel, {
                        size: "maximized",
                        resizable: false
                    }, {
                        body: _withCtx(() => [
                            _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_hit_form, {
                                    name: "RegisterEmailForm",
                                    value: _ctx.objectFirstFormData,
                                    validations: _ctx.validationsFirstForm,
                                    "force-cancel-button-hidden": true,
                                    "force-save-button-hidden": true
                                }, {
                                    default: _withCtx(({ formData, validationState, }) => [
                                        _createVNode(_component_hit_input, {
                                            name: "email",
                                            class: "text-sm sm:text-base",
                                            value: formData.email,
                                            "validation-state": validationState.email,
                                            label: _ctx.t('admin-ui.email'),
                                            "inline-input": "",
                                            onInput: _ctx.onChangeMail
                                        }, null, 8, ["value", "validation-state", "label", "onInput"])
                                    ]),
                                    _: 1
                                }, 8, ["value", "validations"])
                            ])
                        ]),
                        _: 1
                    })
                ])
            ]),
            _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_hit_button, {
                    color: "accent",
                    "suffix-icon": "send",
                    "icon-size": "lg",
                    disabled: !_ctx.emailCompleted,
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('sendMail', { email: _ctx.objectFirstFormData.email })))
                }, null, 8, ["disabled"])
            ])
        ]),
        (_ctx.showBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_hit_banner, {
                    "show-animation": _ctx.showAnimationBanner,
                    onClose: _cache[1] || (_cache[1] = ($event) => (_ctx.closeBanner()))
                }, {
                    "dynamic-content": _withCtx(() => [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.textBanner), 1)
                    ]),
                    default: _withCtx(() => [
                        _hoisted_21
                    ]),
                    _: 1
                }, 8, ["show-animation"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
